import * as React from 'react';
import { SVGProps } from 'react';

const SvgAromatherapy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M32.188 35.936a9.667 9.667 0 0 0 2.39-11.27 11.756 11.756 0 0 0-1.764-2.698 24.182 24.182 0 0 0-6.387-5.026 5.723 5.723 0 0 1-2.911-4.96v-1.184h-7.112v1.185a5.738 5.738 0 0 1-2.907 4.969 23.996 23.996 0 0 0-6.391 5.016 12.096 12.096 0 0 0-1.764 2.698 9.563 9.563 0 0 0 .285 8.62C5.917 33.69 6.9 34.7 8.5 35.5"
    />
    <path fill={props.fill} d="M3.375 32.134h32.397v4.741H8.14l-4.765-4.741Z" />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M8.353 20.547a34.394 34.394 0 0 0 11.602 2 34.47 34.47 0 0 0 11.593-1.996M21.454 9.612c0-.612.347-.875.546-1.112.25-.297.402-.72.402-1.43s-.43-1.04-.902-1.57c-.182-.204-1-1-.5-1.5 0 0 .5-.5.5-1v-.5m-3.046 7.112c0-.612.347-.875.546-1.112.25-.297.402-.72.402-1.43s-.43-1.04-.902-1.57c-.182-.204-1-1-.5-1.5 0 0 .5-.5.5-1v-.5"
    />
  </svg>
);

export default SvgAromatherapy;
